<template>
  <section
    :id="section.id"
    class="content-section"
  >
    <div class="container relative">
      <div class="small-content">
        <div class="columns flex items-center justify-between">
          <div class="left-col">
            <h2
              :class="[
                'section-title section-title-margin',
                section.is_visible ? 'fade-in' : 'fade-out',
              ]"
            >
              {{ getContent('section_1.title_row_1') }}
              <br>
              {{ getContent('section_1.title_row_2') }}
            </h2>
            <div
              :class="[
                'content-text',
                section.is_visible ? 'fade-in' : 'fade-out',
              ]"
              :style="{ transitionDelay: getFadeTransitionDelay(1) }"
            >
              <p>
                "{{ getContent('section_1.description_paragraph_1') }}"
              </p>
              <br>
              <p>
                {{ getContent('section_1.description_paragraph_2') }}
              </p>
            </div>
          </div>
          <div
            :class="[
              'right-col',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(2) }"
          >
            <NuxtImg
              width="442"
              height="442"
              loading="lazy"
              sizes="249px sm:442px"
              src="/content_section_one_hero.webp"
              :alt="getContent('section_1.image_alt')"
              class="content-image levitation"
            />
            <div class="content-image-background bg-image rotation" />
          </div>
        </div>
      </div>
    </div>
    <div class="comet bg-image" />
  </section>
</template>

<script>
export default {
  name: 'ContentSectionOne',
  data: () => ({
    section: {
      id: contentSectionId.one,
      is_visible: true,
    },
  }),
  mounted() {
    this.section.is_visible = false
    initObserver(this.section)
  },
}
</script>

<style lang="scss" scoped>
.content-section {
  padding-top: 164px;
  position: relative;

  .columns {
    flex-direction: row;
    gap: 32px;

    .left-col {
      z-index: 1;
      max-width: 442px;
      position: relative;
    }

    .right-col {
      position: relative;

      .content-image {
        z-index: 2;
        width: 442px;
        height: 442px;
        object-fit: cover;
        position: relative;
      }

      .content-image-background {
        top: 50%;
        left: 50%;
        z-index: 1;
        width: 642px;
        height: 642px;
        position: absolute;
        transform: translate(-50%, -50%);
        background-image: url('@/assets/images/content_section_two_portal.webp');
      }
    }
  }

  .comet {
    top: 0%;
    left: 0%;
    width: 318px;
    height: 246px;
    position: absolute;
    background-image: url('@/assets/images/content_section_two_comet.webp');
  }
}

@media only screen and (max-width: $sm) {
  .content-section {
    padding-top: 32px;

    .comet {
      top: -156px;
      left: -160px;
    }

    .columns {
      flex-direction: column;

      .left-col {
        max-width: 100%;
      }

      .right-col {
        margin-top: 89px;
        position: relative;

        .content-image {
          width: 249px;
          height: 249px;
          object-fit: cover;
        }

        .content-image-background {
          width: 360px;
          height: 360px;
        }
      }
    }
  }
}
</style>
